import ServerApi from "./../../libs/api-services/server-api"
import {cacheSrv} from "./../../libs/cache/cache"
class SubscriptionService extends ServerApi {
  async loadSubscription() {
    let userSubscription = await this.get("/v1/secure/subscriptions")
    if (!userSubscription) {
      console.log("Failed to load subscription")
      return null
    }
    cacheSrv.cache("userSubscription", userSubscription.subscription)
    return userSubscription
  }
}

export const subscriptionService = new SubscriptionService()
